'use client';
import { memo, createElement, Children, isValidElement, cloneElement } from 'react';
import { forwardRef } from './forward-ref.mjs';
import { mergeProps } from '@vtmn-play/utils';
import { combinedRef } from '../hooks/useMultipleRefs.mjs';
import '@xstate/react';

const VpPoly = memo(
  forwardRef((props, ref) => {
    const { asChild, as: Component = "div", children, ...restProps } = props;
    if (!asChild)
      return createElement(Component, { ...restProps, ref }, children);
    const onlyChild = Children.only(children);
    const isValidChild = isValidElement(onlyChild);
    if (!onlyChild || !isValidChild)
      return createElement(Component, { ...restProps, ref }, children);
    const onlyChildRef = onlyChild.ref;
    return cloneElement(onlyChild, {
      ...mergeProps(restProps, onlyChild.props),
      ref: ref ? combinedRef([ref, onlyChildRef]) : onlyChildRef
    });
  })
);

export { VpPoly };
